<ng-template #notifyOrConfirmModal let-c="close" let-d="dismiss">
	<div class="error-modal-backdrop" *ngIf="config.type === notifyOrConfirmType.ERROR">
		<div class="proceeds-modal"></div>
	</div>

	<div id="notify-or-confirm-modal">
		<div class="modal-header">
			<h4 class="modal-title mr-4 ellipsis" [innerHTML]="config.title" [title]="config.title"></h4>
			<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<cfe-icon [iconName]="'close'"></cfe-icon>
			</button>
		</div>
		<div class="modal-body">
			<img *ngIf="config.type != notifyOrConfirmType.SUCCESS" class="modal-icon mb-3" src="{{ config.icon }}" alt="" />
			<cfe-icon *ngIf="config.type === notifyOrConfirmType.SUCCESS" [iconName]="config.icon" class="text-success"></cfe-icon>
			<p class="mb-0" [innerHTML]="config.message"></p>
		</div>

		<div *ngIf="config.type !== notifyOrConfirmType.CONFIRMATION" class="align-items-center modal-footer">
			<button type="button" class="btn btn-primary" (click)="c('OK click')">
				{{ config.buttonText }}
			</button>
		</div>

		<div
			*ngIf="config.type === notifyOrConfirmType.CONFIRMATION"
			class="d-flex flex-column flex-sm-row justify-content-center modal-footer"
		>
			<button type="button" class="btn btn-outline-primary" (click)="d('Cancel click')" id="a-cancel">
				{{ config.buttons.cancelButtonText | translate }}
			</button>
			<button type="button" class="btn btn-primary" id="config-button-confirm" (click)="c('Confirm click')">
				{{ config.buttons.confirmButtonText | translate }}
			</button>
		</div>
	</div>
</ng-template>
